/**
 * Copyright (c) Nicolas Gallagher.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */
var isWebColor = function isWebColor(color) {
  return color === 'currentcolor' || color === 'currentColor' || color === 'inherit' || color.indexOf('var(') === 0;
};

export default isWebColor;


//////////////////
// WEBPACK FOOTER
// ./~/react-native-web/dist/modules/isWebColor/index.js
// module id = 3714
// module chunks = 16